export class EModule {

    ID: number;
    VQuad_Timestamp: Date;
    Call_Timestamp: Date;
    Location: string;
    Phone_ID: string;
    //VQuad_Location: string;
    //VQuad_PhoneID: string;
    GPS_Position: string;
    GPS_Lat: number;
    GPS_Long: number;
    MOS_CQ: number;
    RFactor: number;
    RTD: number;
    VBA_Rating: string;
    EM_ELAPSED: number;
    EM_ASL: number;
    EM_AF: number;
    EM_RMS: number;
    EM_NOISE: number;
    Psophometric_Noise: number;
    CMessage_Noise: number;
    EM_CLIP: number;
    EM_MAXP: number;
    EM_MAXN: number;
    EM_DC: number;

    CallType_Orig: string;
    CallType_Term: string;
    VQuad_CallID: string;

    // MOS_LQ: number;

    //MOS_PQ: number;
    //MOS_MON: number;
    //UserID: string;

constructor() {
  this.ID = 0;
  this.VQuad_Timestamp = new Date();
  this.Call_Timestamp = new Date();
  this.Location = "";
  this.Phone_ID = "";
  //this.VQuad_Location = "";
  //this.VQuad_PhoneID = "";
  this.GPS_Position = "";
  this.GPS_Lat = 0;
  this.GPS_Long = 0;
  this.MOS_CQ = 0;
  this.RFactor = 0;
  this.RTD = 0;
  this.VBA_Rating = "";
  this.EM_ELAPSED = 0;
  this.EM_ASL = 0;
  this.EM_AF = 0;
  this.EM_RMS = 0;
  this.EM_NOISE = 0;
  this.Psophometric_Noise = 0;
  this.CMessage_Noise = 0;
  this.EM_CLIP = 0;
  this.EM_MAXP = 0;
  this.EM_MAXN = 0;
  this.EM_DC = 0;

  this.CallType_Orig = "";
  this.CallType_Term = "";
  this.VQuad_CallID = "";

    // this.MOS_LQ = 0;

    //this.MOS_PQ = 0;
    //this.MOS_MON = 0;
    //this.UserID = "";
    }
 
  
}
